import { Spin } from 'antd';

// ==============================|| Loader ||============================== //

const Loader = () => (
  <div className="fixed top-0 left-0 z-[2001] w-full flex items-center justify-center h-screen bg-white/80">
    <Spin size="large" />
  </div>
);

export default Loader;
